import { Link } from "react-router-dom";
import { normalizeSiteContent } from "../utils/siteContent";

export default function ServicesPage({ content }) {
  const safeContent = normalizeSiteContent(content);

  return (
    <div className="page-shell section-gap" data-testid="services-page">
      <section className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-end" data-testid="services-hero-section">
        <div className="space-y-5">
          <p className="eyebrow" data-testid="services-eyebrow">
            Practice areas
          </p>
          <h1 className="headline-lg max-w-2xl" data-testid="services-heading">
            Legal services designed for pressure, complexity, and decisive action.
          </h1>
        </div>
        <p className="body-copy max-w-3xl" data-testid="services-intro-copy">
          From immigration guidance to civil litigation, employment disputes, and compensation claims, the focus is always the same: understand the stakes quickly, prepare thoroughly, and move toward the strongest available outcome.
        </p>
      </section>

      <section className="mt-16 grid gap-6 lg:grid-cols-2" data-testid="services-grid-section">
        {safeContent.services.map((service, index) => (
          <article className="panel-card" data-testid={`services-card-${index + 1}`} key={service.title}>
            <p className="text-xs font-bold uppercase tracking-[0.26em] text-amber-700" data-testid={`services-card-highlight-${index + 1}`}>
              {service.highlight}
            </p>
            <h2 className="mt-5 text-3xl font-black uppercase tracking-tight text-slate-950" data-testid={`services-card-title-${index + 1}`}>
              {service.title}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-slate-600" data-testid={`services-card-description-${index + 1}`}>
              {service.description}
            </p>
          </article>
        ))}
      </section>

      <section className="mt-20 grid gap-8 md:grid-cols-[1.1fr_0.9fr]" data-testid="services-approach-section">
        <div className="panel-card bg-slate-950 text-white" data-testid="services-approach-card">
          <p className="text-xs font-bold uppercase tracking-[0.26em] text-amber-400" data-testid="services-approach-eyebrow">
            Philosophy of advocacy
          </p>
          <h2 className="mt-4 text-3xl font-black uppercase tracking-tight" data-testid="services-approach-heading">
            Prepared early. Negotiated firmly. Litigated when necessary.
          </h2>
          <div className="mt-6 space-y-4">
            {safeContent.profile_summary.map((paragraph, index) => (
              <p className="text-sm leading-relaxed text-slate-300" data-testid={`services-approach-copy-${index + 1}`} key={paragraph}>
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        <div className="panel-card bg-slate-50" data-testid="services-focus-list-card">
          <p className="text-xs font-bold uppercase tracking-[0.26em] text-amber-700" data-testid="services-focus-eyebrow">
            Client focus
          </p>
          <div className="mt-6 space-y-5">
            {safeContent.stats.map((stat, index) => (
              <div className="border-t border-slate-900/10 pt-5" data-testid={`services-focus-item-${index + 1}`} key={stat.label}>
                <p className="text-2xl font-black uppercase tracking-tight text-slate-950" data-testid={`services-focus-value-${index + 1}`}>
                  {stat.value}
                </p>
                <p className="mt-2 text-xs font-bold uppercase tracking-[0.26em] text-slate-500" data-testid={`services-focus-label-${index + 1}`}>
                  {stat.label}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-slate-600" data-testid={`services-focus-detail-${index + 1}`}>
                  {stat.detail}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mt-20 border border-slate-900/10 bg-white p-8 md:p-12" data-testid="services-cta-section">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div className="space-y-3">
            <p className="eyebrow" data-testid="services-cta-eyebrow">
              Need legal clarity?
            </p>
            <h2 className="text-3xl font-black uppercase tracking-tight text-slate-950" data-testid="services-cta-heading">
              Discuss your matter directly with the firm.
            </h2>
          </div>
          <Link className="solid-button" data-testid="services-cta-button" to="/contact">
            Contact the office
          </Link>
        </div>
      </section>
    </div>
  );
}